import React from 'react';

import AudioInputList from './AudioInputList/AudioInputList';
import AudioOutputList from './AudioOutputList/AudioOutputList';
import { DialogContent, Divider, Dialog, DialogActions, Theme } from '@material-ui/core';
import { Text, Button } from '../DesignSystem';
import { makeStyles } from '@material-ui/core/styles';
import VideoInputList from './VideoInputList/VideoInputList';

const useStyles = makeStyles((theme: Theme) => ({
  title: {
    fontSize: 22,
    margin: '12px',
  },
  container: {
    width: '600px',
    minHeight: '400px',
    [theme.breakpoints.down('xs')]: {
      width: 'calc(100vw - 32px)',
    },
    '& .inputSelect': {
      width: 'calc(100% - 35px)',
    },
  },
  button: {
    float: 'right',
  },
  paper: {
    [theme.breakpoints.down('xs')]: {
      margin: '16px',
    },
  },
  headline: {
    marginBottom: '1.3em',
    fontSize: '1.1rem',
  },
  listSection: {
    margin: '2em 0 0.8em',
    '&:first-child': {
      margin: '1em 0 2em 0',
    },
  },
}));

export default function DeviceSelectionDialog({ open, onClose }: { open: boolean; onClose: () => void }) {
  const classes = useStyles();

  return (
    <Dialog open={open} onClose={onClose} classes={{ paper: classes.paper }}>
      <Text preset="SubHeader" tx="settings.audioVideoSettions" className={classes.title} />
      <Divider />
      <DialogContent className={classes.container}>
        <div className={classes.listSection}>
          <Text preset="Label1" tx="settings.video" className={classes.headline} />
          <VideoInputList />
        </div>
        <Divider />
        <div className={classes.listSection}>
          <Text preset="Label1" tx="settings.audio" className={classes.headline} />
          <AudioInputList />
        </div>
        <div className={classes.listSection}>
          <AudioOutputList />
        </div>
      </DialogContent>
      <Divider />
      <DialogActions>
        <Button color="primary" variant="contained" className={classes.button} onClick={onClose} tx="common.done" />
      </DialogActions>
    </Dialog>
  );
}
